<template>
  <div class="login">
    <img src="../assets/img/logo.png">
      <form v-on:submit.prevent="login">
        <b-container fluid>
          <b-row class="text-center">
            <b-col cols="12" class="py-3">
              <b-alert variant="success" v-show="errorMessage != null">{{errorMessage}}</b-alert>
              <input class="w-25 form-control" style="display: -webkit-inline-box !important"
                type="email" v-model="email" placeholder="Email"><br>
              <input class="w-25 form-control" style="display: -webkit-inline-box !important"
                type="password" v-model="password" placeholder="Senha"><br>
              <b-button variant="outline-primary" class="button" type="submit">Entrar</b-button>
            </b-col>
          </b-row>
        </b-container>
      </form>
  </div>
</template>
<script>
import firebase from 'firebase/app';

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      errorMessage: null,
    };
  },
  methods: {
    login() {
      firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
        (user) => {
          if (user) {
            this.errorMessage = null;
            this.$router.replace('home');
          }
        },
        (err) => {
          this.errorMessage = err.message;
        },
      );
    },
  },
  created() {
    this.$store.commit('setLoading', false);
  },
};
</script>
<style scoped>
.login {
  margin-top: 40px;
}
input {
  margin: 10px 0;
  width: 10%;
  cursor: pointer;
}
button {
  margin-top: 10px;
  width: 10%;
  cursor: pointer;
}
</style>
